import HasFormMutations from "@/store/base/hasForm/mutations"

export default Object.assign(HasFormMutations, {
  //
})